import './polyfills';
import { initSearchandiser } from './searchandiser';
import './tags/index';

export = initSearchandiser();



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./~/source-map-loader!./src/index.ts
 **/